import { MessageCircle } from "lucide-react";
import { WA_LINK } from "@/lib/site";

export const WhatsAppFloat = () => (
  <a
    href={WA_LINK}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Falar com a KRONO no WhatsApp"
    data-testid="whatsapp-float"
    className="group fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center bg-krono text-black transition-transform hover:scale-110"
  >
    <span className="animate-ping-slow absolute inset-0 bg-krono" aria-hidden="true" />
    <MessageCircle className="relative h-6 w-6" />
  </a>
);
